<template>
  <div class="item-row-quote-builder-misc quote-builder-item-row type-misc"
    :id="item.quoteItemId"
    :class="[{'is-selected' : isSelected, 'is-open' : isSelected && !isFullWidth}, `quote-builder-item-${$theme.name}`, defaultRowColourClass(item, getItemAssessments(item), displayDeleted), rowDisplayStatus(item, getItemAssessments(item)) ]"
    @click="event => handleClick(event)">

    <!--------------------------------------------------------------- Main Grid --------------------------------------->
    <quote-builder-misc-item-template :is-full-width="isFullWidth"
      :is-fully-expanded="isSelected && !isFullWidth"
      :is-selected="isSelected"
      @handleClick="handleClick">
      <template v-slot:description>
        <div class="fixed-grid has-12-cols">
          <div class="grid is-align-items-center">
            <!------- Description ------->
            <div class="cell is-col-span-11 is-flex is-flex-direction-column"
              :class="[defaultCellColourClass(item,'itemDesc')]">
              <item-description-autocomplete v-if="isSelected && !item.deleteOtherItem && !readOnlyComputed && !readOnlyView && !audanetLock && $company.setting.itemAutoCompleteEnabled && !isItemRemoved(item, getItemAssessments(item))"
                v-model="item.itemDesc"
                v-focus-next:callback="handleTransitionNextRow"
                v-focus-next-element-on-arrow-directive:callback="handleArrowKeys"
                schedule-id=""
                body-id=""
                :id="item.quoteItemId + '-itemDesc'"
                :class-prop="(!isValidItemDesc(item.quoteItemId) ? 'is-danger ': '') + defaultRowColourClass(item, getItemAssessments(item))"
                :item-type="itemTypes.MISC"
                :times-style="itemTypes.MISC" />
              <input v-else-if="isSelected && !item.deleteOtherItem && !readOnlyComputed && !readOnlyView && !audanetLock && !$company.setting.itemAutoCompleteEnabled && !isItemRemoved(item, getItemAssessments(item))"
                class="input"
                :class="[defaultRowColourClass(item, getItemAssessments(item)), !isValidItemDesc(item.quoteItemId) ? 'is-danger': '']"
                placeholder="Item Description"
                :id="item.quoteItemId + '-itemDesc'"
                v-focus-next-element-on-arrow-directive:callback="handleArrowKeys"
                v-model="item.itemDesc">
              <span v-else
                class="is-quote-item-field-editable pl-2"
                :id="item.quoteItemId + '-itemDesc'"
                :class="{ 'has-text-danger is-italic': !isValidItemDesc(item.quoteItemId) }">{{ item.itemDesc || 'Description' }}</span>
            </div>

          </div>
        </div>
      </template>

      <!------------------- Report Only ------------>
      <template v-slot:report_blend>
        <div class="is-flex is-clickable"
          :class="{'disabled' : item.deleteOtherItem || !canMakeReportOnly(item)}"
          @click="updateReport(item, $event)">
          <span v-tippy="{ theme: 'secondary', enabled: true }"
            content="Report"
            :class="item.reportOnly ? 'is-dark is-danger' : 'is-white'"
            class="tag p-1 px-2">
            R
          </span>
        </div>
      </template>

      <!-------------------------------Total Value  ---------------------->
      <template v-slot:total_value>
        <div class="is-flex"
          :class="[defaultCellColourClass(item,'value')]">
          <vue-numeric v-if="isSelected && !readOnlyComputed && !readOnlyView && !audanetLock && !isItemRemoved(item, getItemAssessments(item))"
            class="input has-text-right"
            :id="item.quoteItemId + '-value'"
            :class="defaultRowColourClass(item, getItemAssessments(item))"
            v-model.number="item.value"
            v-focus-next:callback="handleTransitionNextRow"
            v-focus-next-element-on-arrow-directive:callback="handleArrowKeys"
            :disabled="item.quantityReceived>0 && !$userInfo.isSupportUser"
            :precision="2"
            :minus="true"
            @input="updateTotal(item)" />
          <span v-else
            :id="item.quoteItemId + '-value'"
            class="is-quote-item-field-editable"
            :class="{ 'has-text-danger': !item.value }">
            {{ $filters.formatCurrency(item.value, $userInfo.locale, false, 2) }}
          </span>
        </div>
      </template>

      <!------------------- Present As ------------>
      <template v-slot:present_as>
        <present-as-component :item="item"
          @handlePresentAs="!readOnlyComputed && $emit('handlePresentAs', item)" />
      </template>

      <!---------------------- Comment   ---------------->
      <template v-slot:comment
        v-if="item.itemComment">
        <div v-tippy="{ theme: 'secondary', enabled: true, content:item.itemComment }">
          <span class="mdi has-text-primary is-primary mdi-18px mdi-message-reply-text mr-1 is-clickable" />
        </div>
      </template>

      <template v-slot:assessment_status>
        <supplementary-icon v-if="(innerValue.quoteAssessments?.length || 0) > 0"
          :item="item"
          :item-assessments="getItemAssessments(item)"
          :next-assessment-number="nextSupplemetryNo"
          :quoting-method="innerValue.quotingMethod"
          :icon-size="4"
          class="icon" />
      </template>

      <template v-slot:delete_button>
        <button class="button is-ghost tooltip is-align-items-center p-0 mx-1 has-text-grey-lighter"
          data-tooltip="Delete Misc Item"
          @click="$emit('deleteItem', item)"
          :disabled="readOnlyComputed">
          <span class="material-symbols-rounded "
            :class="{'is-clickable' : !readOnlyComputed}"
            @mouseenter="$event.target.classList.add('has-text-danger')"
            @mouseleave="$event.target.classList.remove('has-text-danger')">
            delete
          </span>
        </button>
      </template>

      <template v-slot:drag_handle>
        <button class="button is-ghost tooltip is-align-items-center p-0 mx-1 item-drag-handle has-text-grey-light"
          data-tooltip="Drag"
          :disabled="readOnlyComputed">
          <span class="mdi mdi-drag-vertical mdi-24px"
            :class="{'is-clickable' : !readOnlyComputed}" />
        </button>
      </template>

      <!----------------- Line No  ------------------------>
      <template v-slot:lineNo>
        <div v-tippy="{ theme: 'secondary', enabled: true, content: 'Line Number' }">
          <vue-numeric v-if="!readOnlyComputed && $userInfo.isSupportUser && !readOnlyView && !isItemRemoved(item, getItemAssessments(item))"
            class="input has-text-right"
            :class="defaultRowColourClass(item, getItemAssessments(item))"
            v-model.number="item.lineNumber"
            v-focus-next:callback="handleTransitionNextRow"
            :precision="0"
            separator="" />
          <span v-else>{{ item.lineNumber }}</span>
        </div>
      </template>

      <!----------------- Item No  ------------------------>
      <template v-slot:itemNo>
        <div v-tippy="{ theme: 'secondary', enabled: true, content: 'Item Number' }">
          <input v-if="!item.deleteOtherItem && !readOnlyComputed && !readOnlyView && !audanetLock && !isItemRemoved(item, getItemAssessments(item))"
            class="input"
            :class="[defaultRowColourClass(item, getItemAssessments(item)), !isValidItemNo(item.quoteItemId) ? 'is-danger': '']"
            placeholder="Item No."
            v-model="item.itemNo"
            v-focus-next:callback="handleTransitionNextRow">
          <span v-else>{{ item.itemNo }}</span>
        </div>
      </template>

      <!------------------Item Status  -------------------->
      <template v-slot:itemStatus>
        <div v-tippy="{ theme: 'secondary', enabled: true, content: 'Item Status' }">
          <input v-if="!readOnlyComputed && !readOnlyView && !isItemRemoved(item, getItemAssessments(item))"
            class="input is-capitalized"
            v-model="item.itemStatus"
            v-focus-next:callback="handleTransitionNextRow">
          <span v-else>{{ item.itemStatus }}</span>
        </div>
      </template>

    </quote-builder-misc-item-template>
  </div>
</template>

<script>
import vueNumeric from '@/components/VueNumeric/vue-numeric.vue'
import { ItemCategoryTypes, QuotingMethodTypes, PartStatusTypes, PartTypes, ItemTypes } from '@/enums'
import QuoteBuilderMiscItemTemplate from '../../templates/QuoteBuilderMiscItemTemplate.vue'
import QuoteFiltersMixins from '../../../QuoteFiltersMixins'
import { QuoteItemValidationMixin, QuoteItemsMixin, QuoteItemDifferenceMixin } from '../../mixins'
import SupplementaryIcon from '../../../components/SupplementaryIcon.vue'
import PresentAsComponent from '../../components/PresentAsComponent.vue'
import ItemDescriptionAutocomplete from '../../../components/ItemDescriptionAutocomplete/ItemDescriptionAutocomplete.vue'
import { FocusNext, FocusNextElementOnArrowDirective } from '@/components/directives'

export default {
  name: 'QuoteBuilderMiscItem',
  directives: {
    FocusNext,
    FocusNextElementOnArrowDirective
  },
  components: { vueNumeric, QuoteBuilderMiscItemTemplate, SupplementaryIcon, PresentAsComponent, ItemDescriptionAutocomplete },
  mixins: [QuoteFiltersMixins, QuoteItemsMixin, QuoteItemValidationMixin, QuoteItemDifferenceMixin],
  props: {
    innerValue: {
      type: Object,
      required: true
    },
    // in a single row view, the row is full width
    isFullWidth: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      required: true
    },
    editItemId: null,
    nextLineNumber: {
      type: Number,
      default: 0
    },
    readOnlyView: {
      type: Boolean,
      default: false
    },
    audanetLock: {
      type: Boolean,
      default: false
    },
    itemsAssessments: {
      type: Array,
      default: () => []
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isPresentAsModalActive: false,
      itemType: 'MISC',
      displayDeleted: false,
      isFloatingWidgetActive: false
    }
  },
  computed: {
    // your computed properties go here
    isSelected() {
      return this.item.quoteItemId === this.editItemId
    },
    PartStatusTypes() {
      return PartStatusTypes
    },
    partTypes() {
      return PartTypes
    },
    itemTypes() {
      return ItemTypes
    },
    nextSupplemetryNo() {
      const nextSuppNo = Math.max(...this.innerValue.quoteAssessments.map((i) => i.subQuoteNo)) + 1
      return nextSuppNo
    },
    readOnlyComputed() {
      return this.innerValue.readOnly || !this.isEditable
    }
  },
  methods: {
    captureItemSnapshot() {
      const i = this.item
      this.itemSnapshot = {
        itemDesc: i.itemDesc,
        value: i.value,
        reportOnly: i.reportOnly,
        lineNumber: i.lineNumber,
        itemNo: i.itemNo,
        itemStatus: i.itemStatus,
        presentAs: JSON.stringify(i.presentAs)
      }
    },
    isItemDirty() {
      if (!this.itemSnapshot) return false
      const i = this.item
      return (
        i.itemDesc !== this.itemSnapshot.itemDesc ||
        i.value !== this.itemSnapshot.value ||
        i.reportOnly !== this.itemSnapshot.reportOnly ||
        i.lineNumber !== this.itemSnapshot.lineNumber ||
        i.itemNo !== this.itemSnapshot.itemNo ||
        i.itemStatus !== this.itemSnapshot.itemStatus ||
        JSON.stringify(i.presentAs) !== this.itemSnapshot.presentAs
      )
    },
    handleArrowKeys(currentIndex, nextIndex, fieldId, isArrowDown) {
      this.$eventHub.$emit('handleArrowKeyFocus', currentIndex, nextIndex, fieldId, this.item, isArrowDown)
    },
    handleTransitionNextRow() {
      this.$emit('focusNextRow', this.item.quoteItemId)
    },
    closeModal() {
      this.isPresentAsModalActive = false
    },
    handleClick(event, close = false) {
      event.stopPropagation()
      this.$emit('itemRowClicked', this.item, event, close)
    },
    updateBlend(item) {
      item.blend = !item.blend

      const isBlend = item.blend
      const itemToUpdate = this.innerValue.labours.find((i) => i.quoteItemId === item.quoteItemId)
      if (item.itemType === ItemCategoryTypes.PAINT && this.isNtar) {
        const value = isBlend ? roundAwayFromZero(item.hourValue * 0.7) : roundAwayFromZero(item.hourValue / 0.7)
        if (this.item.quotingMethod === QuotingMethodTypes.Dollar) {
          itemToUpdate.hourValue = value
          itemToUpdate.dollarValue = item.hourValue
        } else {
          itemToUpdate.hourValue = value
          itemToUpdate.dollarValue = roundAwayFromZero(item.hourValue * item.rate)
        }
        this.updateTotal()
      }
    },

    getItemAssessments(item) {
      const assessments = this.itemsAssessments
      const itemAssessments = assessments.find((i) => i.quoteItemId == item.quoteItemId)
      if (!!itemAssessments) return itemAssessments.assessments
      return []
    },
    updateReport(item, event) {
      if (!item.deleteOtherItem && !this.readOnlyComputed && !this.readOnlyView && !this.audanetLock && this.canMakeReportOnly(item)) {
        if (!this.itemSnapshot) this.captureItemSnapshot()
        item.reportOnly = !item.reportOnly
      }
    },
    updateTotal() {
      this.isFloatingWidgetActive = true
    },
    canMakeReportOnly(item) {
      const assessments = this.getItemAssessments(item)
      if (assessments.length > 0) {
        const lastAssessment = assessments[assessments.length - 1]
        const lastValues = lastAssessment[lastAssessment.length - 1]
        if (!lastValues.reportOnly) {
          return false
        }
      }
      return true
    }
  }
}
</script>

<style lang="scss">
.item-row-quote-builder-misc {
  height: 45px !important;
  // border: 1px solid #adb5bd;
  border-radius: 5px;
  font-size: 0.9em;
  margin-bottom: 5px;
  padding: 2px;
  // align-content: center;
  /* align center vertically */
  // align-items: center;

  .center-y {
    display: flex;
    align-items: center;
  }

  .center {
    display: flex;
    justify-content: center;
  }
  .end {
    display: flex;
    justify-content: flex-end;
  }

  &.is-open {
    height: 85px !important;
  }
}

/* text overflow ellipses */
.item-row-quote-builder-misc span {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>